/** Resolve IDs and display names from appointment DTOs (backend-enriched). */

export const getAppointmentPatientId = (appointment) =>
  appointment?.patientId ??
  appointment?.patient_id ??
  appointment?.patient?.id ??
  appointment?.patient?.patientId ??
  null;

export const getAppointmentDoctorId = (appointment) =>
  appointment?.doctorId ??
  appointment?.doctor_id ??
  appointment?.doctor?.id ??
  appointment?.doctor?.doctorId ??
  null;

const findById = (list, id) => {
  if (id == null || !Array.isArray(list)) return null;
  return list.find((row) => {
    const rowId = row?.id ?? row?.patientId ?? row?.doctorId;
    return Number(rowId) === Number(id) || String(rowId) === String(id);
  });
};

export const getAppointmentPatientName = (appointment, patientsLookup = null) => {
  const embedded =
    appointment?.patientName ||
    appointment?.patient?.name ||
    appointment?.patient?.firstName;
  if (embedded) return embedded;

  const patientId = getAppointmentPatientId(appointment);
  if (!patientId) return "Unknown Patient";

  const patient = findById(patientsLookup, patientId);
  return patient?.name || patient?.firstName || "Unknown Patient";
};

export const getAppointmentDoctorName = (appointment, doctorsLookup = null) => {
  const doctorId = getAppointmentDoctorId(appointment);
  if (!doctorId || Number(doctorId) === 0) return "No Doctor Assigned";

  const embedded =
    appointment?.doctorName ||
    appointment?.doctor?.name ||
    appointment?.doctor?.firstName;
  if (embedded) return embedded;

  const doctor = findById(doctorsLookup, doctorId);
  return doctor?.name || "Unknown Doctor";
};
